import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Col, Row } from 'react-grid-system';
import { RightWrapper } from './styles';
import Label from '../../../components/shared/Label';
import ToggleButton from '../../../components/shared/ToggleButton';
import { isOnlyFirstLeg } from '../../../common/rcs_gaz_mc_core_FE/build/config';

const boolHighlights = () => {
  if (document.querySelector('.myHighlights')) {
    setTimeout(() => {
      if (document.querySelectorAll('.isAnHighlights').length > 0) {
        document.querySelector('.myHighlights').style.display = 'initial';
      } else {
        document.querySelector('.myHighlights').style.display = 'none';
      }
    }, 300);
  }
};

export class CalendarBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    boolHighlights();
  }

  componentDidUpdate() {
    boolHighlights();
  }

  subPhaseLabel = () => {
    let label = `${this.props.currentSubPhase}${this.props.dictionary.competitionTable.dayA}`;
    //Mondiali di Volley Maschile e Femminile
    if (window.matchcenterPage.sportId === '5' && (window.matchcenterPage.competitionId === 34 || window.matchcenterPage.competitionId === 35)) {
      label = `${this.props.currentSubPhase}° Round`;
    }
    return label;
  }

  render() {
    const {
      currentDay,
      actions,
      //favouritesCounter,
      isMobile,
      dictionary,
      hasHighlights,
      isCup,
      currentSubPhase,
      noTitleOnFinal,
      competitionId,
    } = this.props;
    const { sportId } = window.matchcenterPage;
    const onlyFirstLeg = isOnlyFirstLeg(sportId, competitionId);
    return (
      <Container
        fluid
        style={{
          marginTop: isMobile ? '1.3em' : '0em',
          marginBottom: isMobile ? '0.5em' : '15px',
          paddingBottom: isMobile ? '12px' : 'none',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <Row style={{
          alignItems: 'center',
          marginLeft: isMobile ? '8px' : '0px',
          marginRight: isMobile ? '12px' : '0px',
          flexDirection: isMobile && isCup ? 'column-reverse' : 'row',
        }}
        >
          <Col
            md={!isCup && isMobile ? 0 : 5}
            sm={!isCup && isMobile ? 0 : 5}
            xs={!isCup && isMobile ? 0 : 5}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              textAlign: isMobile && isCup ? 'center' : 'left',
              alignSelf: 'center',
              overflow: 'visible',
            }}
          >
            {!isCup && currentDay && !isMobile &&
            <Label
              label={`${currentDay}${dictionary.competitionTable.dayA}`}
              size={1.2}
              margin="0px 0px 0px 0.3em"
              isPageSubTitle
            />
            }
            {isCup && !currentSubPhase && (noTitleOnFinal !== 'final' && competitionId !== 4 && competitionId !== 259 && competitionId !== 105 && !onlyFirstLeg) &&
              <Label
                label={`${dictionary.calendar.legs.firstLeg}`}
                size={1.2}
                margin="0px 0px 0px 0.3em"
                isPageSubTitle
              />
            }
            {isCup && !currentSubPhase && (noTitleOnFinal === 'semi-finals' && (competitionId === 259 || competitionId === 105)) &&
              <Label
                label={`${dictionary.calendar.legs.firstLeg}`}
                size={1.2}
                margin="0px 0px 0px 0.3em"
                isPageSubTitle
              />
            }
            {isCup && !currentSubPhase && (noTitleOnFinal === 'final') && (competitionId === 105) &&
              <Label
                label={`${dictionary.calendar.legs.firstLeg}`}
                size={1.2}
                margin="0px 0px 0px 0.3em"
                isPageSubTitle
              />
            }
            {isCup && currentSubPhase &&
            <Label
              label={this.subPhaseLabel()}
              size={1.2}
              margin="0px 0px 0px 0.3em"
              isPageSubTitle
            />
            }
          </Col>
          <Col
            md={7}
            sm={7}
            xs={7}
            style={{
              paddingLeft: isMobile ? '15px' : '0px', paddingRight: 0, alignSelf: 'flex-start', overflow: 'visible', display: 'none',
            }}
            className="myHighlights"
          >
            <RightWrapper
              isCup={isCup}
              isMobile={isMobile}
            >
              <Label
                label={hasHighlights ? 'nascondi dettagli' : 'mostra dettagli'}
                width="200px"
                alignText={!isMobile ? 'right' : ''}
                size={0.9}
                margin="0px 15px 3px 0px"
                order={isMobile ? 2 : ''}
              />
              <ToggleButton
                checked={hasHighlights}
                actions={actions}
              />
            </RightWrapper>
          </Col>
        </Row>
      </Container>
    );
  }
}

CalendarBar.propTypes = {
  actions: PropTypes.any,
  hasHighlights: PropTypes.bool,
  currentDay: PropTypes.number,
  //favouritesCounter: PropTypes.number,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  isCup: PropTypes.bool,
  currentSubPhase: PropTypes.string,
  noTitleOnFinal: PropTypes.string,
  competitionId: PropTypes.any,
};

export default CalendarBar;



// WEBPACK FOOTER //
// ./src/containers/Calendar/CalendarBar/index.js